import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getRanks } from 'Redux/selectors/rank'
import { getUser } from 'Redux/selectors/auth'
import Component from './Rank'

const selector = createStructuredSelector({
  ranks: getRanks,
  curator: getUser,
})

export default connect(selector, null)(Component)
